const RaindropTextCallout = ({ text, isPrimary = true, className = "" }) => {
  let tailwindTextColor =
    "text-color-text-primary dark:text-color-dark-text-primary ";

  if (isPrimary) {
    tailwindTextColor = "text-color-raindrop-primary  ";
  }

  return (
    <div className={`text-5xl font-black ${tailwindTextColor} ${className}`}>
      {text}
    </div>
  );
};

export default RaindropTextCallout;
